import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchAllVendorRequestsForExport } from 'actions/vendor-request';
import { CSVLink } from 'react-csv';
import { Button } from '@blueprintjs/core';
import isEqual from 'lodash/isEqual';

const headers = [
  { label: 'Third Party Assessment ID', key: 'vendorRequestID' },
  {
    label: 'Questionnaire Completion Date',
    key: 'questionnaireCompletionDate',
  },
  { label: 'Approval Date', key: 'approvalDate' },
  { label: 'Renewal Date', key: 'renewalDate' },
  { label: 'Request Status', key: 'requestStatus' },
  { label: 'Sponsor Email', key: 'sponsorInformation.email' },
  { label: 'Sponsor Department', key: 'sponsorInformation.department' },
  { label: 'Third Party Name', key: 'vendorInformation.vendorName' },
  { label: 'Third Party Contact', key: 'vendorContact.email' },
  { label: 'Product/Service Name', key: 'productServiceName' },
  { label: 'Description', key: 'description' },
  { label: 'Req/PO Invoice', key: 'reqPoInvoice' },
  { label: 'Departments Requesting', key: 'departmentsRequesting' },
];

class Export extends Component {
  state = { data: [] };

  componentDidMount() {
    this.props.fetchAllVendorRequestsForExport({
      start: 0,
      limit: -1,
      ...this.props.exportParams,
    });
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.exportParams, this.props.exportParams)) {
      this.props.fetchAllVendorRequestsForExport({
        start: 0,
        limit: -1,
        ...this.props.exportParams,
      });
    }
  }
  render() {
    const { exportsLoaded } = this.props;
    return (
      <React.Fragment>
        {exportsLoaded && (
          <CSVLink
            data={this.props.exports}
            headers={headers}
            asyncOnClick={true}
            filename="third-party-requests.csv"
          >
            <Button
              minimal={true}
              icon="export"
              intent="primary"
              text="EXPORT"
            />
          </CSVLink>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  exports: state.vendorRequest.exports,
  exportsLoaded: state.vendorRequest.exportsLoaded,
});

Export = connect(
  mapStateToProps,
  { fetchAllVendorRequestsForExport }
)(Export);

export default Export;
